import searchQueryState from './SearchQuery'
import searchConfig from './SearchConfiguration'

export default {
  useRouterHelper(router, baseUrl) {
    const {
      getActiveConfig
    } = searchConfig.searchConfigurationUse()

    const { searchQuery } = searchQueryState.searchQueryUse()

    function updateRoute() {
      const query = {}
      const queryParams = new URLSearchParams(window.location.search)

      const config = getActiveConfig()
      const filterParams = config.categories.flatMap((a) => a.categories)
        .filter((x) => searchQuery.activeCategories.includes(x.name))
        .map((category) => category.slug).filter((x) => x)
        .sort()

      const path = baseUrl.concat(filterParams.join('+')).concat('/')

      const termsUrl = searchQuery.terms.sort().join('+')
      if (termsUrl !== '') {
        query.query = termsUrl
      }

      const defaultSorting = config.sortingOptions.find((x) => x.default).value
      if (searchQuery.sorting && searchQuery.sorting !== defaultSorting) {
        query.sorting = searchQuery.sorting
      }

      if (config.viewOptions && config.viewOptions.length > 1) {
        const defaultView = config.viewOptions.find((x) => x.default).value
        if (searchQuery.view && searchQuery.view !== defaultView) {
          query.sorting = searchQuery.sorting
        }
      }

      // SEO requirement
      if (filterParams.length || searchQuery.terms.length) {
        queryParams.delete('skip')
      }

      if (queryParams.has('skip')) {
        query.skip = queryParams.get('skip')
      }

      router.push({
        path,
        query
      }).catch(() => {})
    }

    function getRouteData() {
      let href = router.currentRoute.path.substr(router.currentRoute.path.lastIndexOf(baseUrl) + baseUrl.length)

      if (href.endsWith('/')) {
        href = href.substring(0, href.length - 1)
      }
      const filters = href.substring(href.lastIndexOf('/') + 1)
      const activeFiltersSlugs = (filters || '').split('+').filter((t) => t)

      const config = getActiveConfig()
      const searchType = config.type

      const activeCategories = config.categories.flatMap((a) => a.categories)
        .filter((x) => activeFiltersSlugs.includes(x.slug)).map((x) => x.name)

      const terms = (router.currentRoute.query.query || '').split('+').filter((t) => t)
      const sorting = router.currentRoute.query.sorting || null
      const view = router.currentRoute.query.view || null

      return {
        activeCategories,
        searchType,
        terms,
        sorting,
        view
      }
    }

    return {
      getRouteData,
      updateRoute
    }
  }
}
